(ns app.front.view.group.admin.package-template-editor
  (:require [app.domain.package.model :as package-model]
            [app.domain.util :as du]
            [app.front.entities :as entities]
            [app.front.entity-edit :as ee]
            [app.front.file.download :as file-download]
            [app.front.ui :as ui]
            [app.front.ui.text-editor :as text-editor]
            [app.front.util :as futil :refer [for-frag]]
            [app.front.view.group.admin.common :as acommon]
            [app.front.view.group.admin.review-config :as review-config]
            [app.front.view.group.admin.subs :as gas]
            [app.front.view.group.admin.templates.document-editor :as document-editor]
            [app.front.view.group.admin.templates.language-selector :as lang-sel]
            [app.front.view.group.admin.verdict-template.edit :as verdict-template-edit]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]
            [core.front.feature-flags :as ff]
            [core.util.string :as str-util]
            [re-frame.core-instrumented :as rf])
  (:require-macros [core.util.util :as util]))


(defn set-attr-evt [template-id attr value]
  (if (keyword? template-id)
    [::ee/set-value template-id attr value]
    [::ee/save-debounce
     nil
     :package/edit-template
     template-id
     attr
     value
     {:notify {:success :template-editor/template-saved}}]))


(rf/reg-event-fx ::set-attr
  (fn [_ [_ template-id attr value]]
    {:dispatch (set-attr-evt template-id attr value)}))

(def new-document-id ::new)

(rf/reg-sub ::unsaved
  :<- [::ee/unsaved-for new-document-id]
  (fn [unsaved _]
    unsaved))

(rf/reg-event-fx ::create
  (fn [_ [_ group-id permit-type data]]
    {:comm/command {:command    :package/create-template
                    :data       (assoc data
                                       :group-id group-id
                                       :template/permit-type permit-type)
                    :method     :post
                    :on-success [::create.success group-id]
                    :notify     {:success :admin-package/template-created}}}))


(rf/reg-event-fx ::create.success
  (fn [_ [_ group-id status changes]]
    {:fx            [[:dispatch [::entities/apply-changes status changes]]
                     [:dispatch [::ee/cancel-changes new-document-id]]]
     :route/replace {:route  :view/group.admin.template
                     :params {:template-id (entities/id-of-some-in-apply-changes :entity.type/package-pdf-template
                                                                                 changes)
                              :group-id    group-id}}}))

(rf/reg-event-fx ::set-enabled
  (fn [_ [_ template-id enabled?]]
    {:comm/command {:command    :package/edit-template
                    :method     :post
                    :data       {:id    template-id
                                 :attr  :domain/state
                                 :value (if enabled?
                                          :package-pdf-template.state/active
                                          :package-pdf-template.state/disabled)}
                    :on-success [::entities/apply-changes]}}))

(rf/reg-sub ::create-disabled?
  :<- [::ee/attr-value new-document-id :package-pdf-template/name]
  (fn [name-value _]
    (nil? (str-util/blank->nil name-value))))

(defn create-controls [{:keys [tr group-id permit-type]}]
  (let [unsaved (<sub [::unsaved])]
    [:div.mt-4
     (cc/button {:on-click #(>evt [::create group-id permit-type unsaved])
                 :disabled (<sub [::create-disabled?])}
                (tr [:create]))]))

(defn feature-toggle [{:keys [tr document-id template section-key attr inherited?]}]
  (let [sections-val (or (<sub [::ee/attr-value document-id attr])
                         (get template attr)
                         #{})
        checked      (contains? sections-val section-key)]
    (cc/checkbox {:id         (str document-id "-checkbox-" (name section-key))
                  :disabled   inherited?
                  :label-text (tr [section-key])
                  :checked    checked
                  :on-change  #(>evt [::set-attr document-id attr
                                      (if checked
                                        (disj sections-val section-key)
                                        (conj sections-val section-key))])})))

(defn view [tr group-id permit-type template inherited?]
  (let [document-id                (:db/id template new-document-id)
        images                     (<sub [::gas/verdict-images group-id])
        permit-type                (or (some->> permit-type (keyword "permit-type"))
                                       (:template/permit-type template)
                                       (<sub [::gas/group-primary-permit-type group-id]))
        feature-flags              (<sub [::ff/enabled-flags])
        variables                  (cond->> (package-model/picker-variables-for-type permit-type feature-flags)
                                     (not (ff/enabled? :feature-flag.id/allow-multiple-categories-to-a-case))
                                     (remove #(= % "additional-categories")))
        html                       (package-model/html-for-type permit-type)
        review-placeholder-options {:review-configs (<sub [::review-config/available-review-configs group-id])}]
    [acommon/section {:title (str (tr [:admin-package/template])
                                  (when (<sub [::gas/superdomain-group?])
                                    (str " (" (tr [permit-type]) ")")))}
     [:div.flex.justify-between
      [ui/text-input {:label-text (tr [:admin-package/name])
                      :disabled   inherited?
                      :required   true
                      :class      "mr-2"
                      :value      (<sub [::ee/attr-value document-id :package-pdf-template/name])
                      :on-change  #(rf/dispatch-sync (set-attr-evt document-id
                                                                   :package-pdf-template/name
                                                                   (futil/tval %)))}]
      [:div.w-1-3
       [lang-sel/language-selector {:language  (<sub [::ee/attr-value document-id :entity/language])
                                    :on-change #(>evt [::set-attr document-id :entity/language %])}]]]
     (when template
       (cc/toggle {:id         (str "enabled-" (:db/id template))
                   :class-name "my-4"
                   :toggled    (if inherited?
                                 (-> (<sub [::gas/group-inherited-template-ids]) (contains? (:db/id template)))
                                 (->> template
                                      (du/in-state? :package-pdf-template.state/disabled)
                                      not))
                   :label-text (tr [:admin/enable-template])
                   :on-toggle  #(if inherited?
                                  (>evt [::verdict-template-edit/set-inherited-available group-id (:db/id template) %1])
                                  (>evt [::set-enabled (:db/id template) %1]))}))
     [:div.flex.flex-col.mt-4
      [:h5 (tr [:package-pdf-template/include-sections])]
      (for-frag [section-key (->> permit-type
                                  package-model/sections-for-type
                                  (keep package-model/optional-sections))]
        [feature-toggle (util/mmap {:attr :package-pdf-template/include-sections} section-key tr document-id template inherited?)])]
     (when-let [attachment-sections (->> permit-type
                                         package-model/attachments-for-type
                                         seq)]
       [:div.flex.flex-col.mt-4
        [:h5 (tr [:package-pdf-template/include-attachments])]
        (for-frag [section-key attachment-sections]
          [feature-toggle (util/mmap {:attr :package-pdf-template/include-attachments} section-key tr document-id template inherited?)])])
     (if (keyword? document-id)
       [create-controls (util/mmap permit-type tr group-id)]
       [document-editor/editor
        (-> (util/mmap {:title              [:h3 (tr [:admin-package/template])]
                        :read-only?         inherited?
                        :preview-url        (file-download/download-href
                                              :group/generate-package-pdf-template-preview
                                              {:group-id    group-id
                                               :template-id document-id})
                        :placeholders       variables
                        :html-fragment-type html
                        :css-fragment-type  :package-fragment/print-css
                        :images             images}
                       tr group-id document-id review-placeholder-options)
            (text-editor/with-external-edit-state ::main))
        [document-editor/editor
         (-> (util/mmap {:title              [:h4 (tr [:admin-package/party-snippet])]
                         :read-only?         inherited?
                         :placeholders       package-model/party-snippet-variables
                         :small?             true
                         :html-fragment-type :package-fragment/party-snippet}
                        tr images group-id document-id)
             (text-editor/with-external-edit-state ::party-snippet))]])]))
